import { Api, IPaginacao } from "../axios-config";
import { IUnidade } from "../unidade/UnidadeService";
import { Environment } from "../../../environment";

export interface ICaixa {
    idCaixa: number,
    localizador: string,
    codigoBarras: string,
    observacao: string,
    identificador: string,
    indice: IIndice_Caixa[],
}

export interface IListagemCaixas extends ICaixa {
    nomeSetor: string[],
    nomeTipo: string[]
}

export interface IConsultaCaixa {
    unidade: IUnidade,
    listagemCaixas: IListagemCaixas[];
    paginacao: IPaginacao
}

export interface IIndice_Caixa {
    idIndice: number,
    idCaixa: number,
    valor: string | null,
    dataInicial: string | null,
    dataFinal: string | null,
}

const getByIdTipo = async (idTipo: number, page = 1, estado: boolean): Promise<IConsultaCaixa | Error> => {
    try {

        const { data } = await Api.get(`Caixa_tipo/pesquisar/caixasPorTipo?PageNumber=${page}&PageSize=${Environment.LIMITE_DE_LINHAS}&idTipo=${idTipo}&estado=${estado}`);

        if (data) {
            return data;
        }

        return new Error('Erro ao listar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao listar os registros');
    }
};

const getByIdSetor = async (idSetor: number, page = 1, estado: boolean): Promise<IConsultaCaixa | Error> => {
    try {

        const { data } = await Api.get(`Setor_caixa/pesquisar/caixasPorSetor?PageNumber=${page}&PageSize=${Environment.LIMITE_DE_LINHAS}&idSetor=${idSetor}&estado=${estado}`);;

        if (data) {
            return data;
        }

        return new Error('Erro ao listar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao listar os registros');
    }
};

const getByLocalizador = async (localizador: string, cnpj: string | null): Promise<{ unidade: IUnidade, caixa: IListagemCaixas } | Error> => {
    try {

        const { data } = await Api.get(`Caixa/localizadorOuIdentificadorOuCodBarras?localizador=${localizador}&cnpj=${cnpj}`);;

        if (data) {
            return data;
        }

        return new Error('Erro ao listar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao listar os registros');
    }
};

const getByIdentificador = async (identificador: string, cnpj: string | null): Promise<{ unidade: IUnidade, caixa: IListagemCaixas } | Error> => {
    try {

        const { data } = await Api.get(`Caixa/localizadorOuIdentificadorOuCodBarras?ident=${identificador}&cnpj=${cnpj}`);;

        if (data) {
            return data;
        }

        return new Error('Erro ao listar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao listar os registros');
    }
};

const getByCodBarras = async (codBarras: string, cnpj: string | null): Promise<{ unidade: IUnidade, caixa: IListagemCaixas } | Error> => {
    try {

        const { data } = await Api.get(`Caixa/localizadorOuIdentificadorOuCodBarras?codBarras=${codBarras}&cnpj=${cnpj}`);;

        if (data) {
            return data;
        }

        return new Error('Erro ao listar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao listar os registros');
    }
};

const getByIndices = async (idTipo: number, dadosIndice: Omit<IIndice_Caixa, 'idCaixa'>[], page = 1): Promise<IConsultaCaixa | Error> => {
    try {
        const { data } = await Api.post(`Caixa/pesquisarPorIndice?PageNumber=${page}&PageSize=${Environment.LIMITE_DE_LINHAS}&idTipo=${idTipo}&estado=true`, dadosIndice);

        if (data) {
            return data;
        }

        return new Error('Erro ao consultar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao consultar o registro');
    }
};

const getReportbyIndices = async (idTipo: number, dadosIndice: Omit<IIndice_Caixa, 'idCaixa'>[], page = 1): Promise<void | Error> => {
    try {
        const response  = await Api.post(`Caixa/relatorioPorIndice?PageNumber=${page}&PageSize=${Environment.LIMITE_DE_LINHAS}&idTipo=${idTipo}&estado=true`, dadosIndice, { responseType: 'blob' });
        
        if(response)
        {
            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const link = document.createElement('a');
            const url = window.URL.createObjectURL(blob);

            link.href = url;
            link.setAttribute('download', 'relatorio_de_pesquisa_de_caixas.xlsx');
            document.body.appendChild(link);
            link.click();

            link.parentNode?.removeChild(link);
            window.URL.revokeObjectURL(url);
        } else {
            return new Error('Erro ao consutar o registro');
        }

    } catch (error) {
        if ((error as { message: string }).message === "[object Blob]") {
            (error as { message: string }).message = `Sem registros em encontrados`
        }
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao consultar o registro');
    }
}


export const Consulta_Caixa_Service = {
    getByIdTipo,
    getByIdSetor,
    getByIndices,
    getByCodBarras,
    getByLocalizador,
    getByIdentificador,
    getReportbyIndices,
}